import File from './file';
import CustomTextTrigger from './customtexttrigger';

export default {
  File,
  CustomTextTrigger,
};
